import { render, staticRenderFns } from "./ArcBg.vue?vue&type=template&id=731983ee&scoped=true&"
import script from "./ArcBg.vue?vue&type=script&lang=js&"
export * from "./ArcBg.vue?vue&type=script&lang=js&"
import style0 from "./ArcBg.vue?vue&type=style&index=0&id=731983ee&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731983ee",
  null
  
)

export default component.exports